const BesqabLogotype = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden='true'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 174 40'
    >
      <path
        d='m108.3 31.8-2.9-2.9c-5.6 5-14.2 4.9-19.6-.5-5.4-5.3-5.6-13.9-.6-19.6l-2.9-2.9c-6.5 7.2-6.3 18.4.7 25.3 3.6 3.6 8.3 5.3 13 5.3 3.1 0 6.2-.8 9-2.4l5.8 5.7 2.8-2.9-5.3-5.1ZM95.9 4.1c3.6 0 7.3 1.4 10.1 4.1 4.8 4.8 5.5 12.1 2.1 17.6l2.9 2.9c4.9-7.2 4.2-17.1-2.2-23.4-6.4-6.3-16.3-7-23.4-2l2.9 2.9c2.3-1.3 5-2.1 7.6-2.1ZM70.2 3.3c-1.8-2-4.3-3.2-7-3.3-5.6-.3-10.4 4.1-10.7 9.7-.2 5.1 3.3 9.5 8.2 10.5V16c-2.5-.9-4.3-3.3-4.1-6.1.2-3.4 3-6 6.4-5.8 1.6.1 3.1.8 4.2 2 1 1 1.5 2.4 1.6 3.8h4c-.1-2.5-1-4.8-2.6-6.6Z'
        fill='currentColor'
      />
      <path
        d='M68.901 26.8c-.1 1.6-.8 3.1-2 4.2s-2.8 1.7-4.4 1.6c-1.6-.1-3.1-.8-4.2-2-1-1.1-1.6-2.6-1.6-4.1h-4c0 2.5.9 4.9 2.6 6.8 1.8 2 4.3 3.2 7 3.3h.5c2.5 0 4.9-.9 6.8-2.6 2-1.8 3.2-4.3 3.3-7 .2-5.1-3.3-9.5-8.2-10.5v4.2c2.5.9 4.3 3.3 4.2 6.1ZM32.7 4.7h14.7v-4H28.6v11.7h4.1V4.7ZM28.6 36.3h18.8v-4H32.7V20.5h11.4v-4H28.6v19.8ZM17.7 18.5c2.4-1.8 3.9-4.7 3.9-7.9 0-5.5-4.5-9.9-9.9-9.9H0v11.8h4V4.7h7.7c3.2 0 5.9 2.6 5.9 5.9 0 3.2-2.6 5.9-5.9 5.9H0v11.8h4v-7.7h7.7c3.2 0 5.9 2.6 5.9 5.9 0 3.2-2.6 5.9-5.9 5.9H0v4h11.8c5.5 0 9.9-4.5 9.9-10 0-3.3-1.6-6.1-4-7.9ZM169.101 18.5c2.4-1.8 3.9-4.7 3.9-7.9 0-5.5-4.5-9.9-9.9-9.9h-11.7v11.8h4V4.7h7.7c3.2 0 5.9 2.6 5.9 5.9 0 3.2-2.6 5.9-5.9 5.9h-11.7v11.8h4v-7.7h7.7c3.2 0 5.9 2.6 5.9 5.9 0 3.2-2.6 5.9-5.9 5.9h-11.8v4h11.8c5.5 0 9.9-4.5 9.9-10 .1-3.3-1.5-6.1-3.9-7.9ZM145.3 30.5l-1.5-4.1L134 .6l-4.3.1-12.2 35.6-.1.1h4.3v-.1l10.2-29.7 6.7 17.6h-8.4l-1.4 4h11.3l.9 2.3 2.2 5.8h4.3l-2.2-5.8Z'
        fill='currentColor'
      />
    </svg>
  );
};
export default BesqabLogotype;
